import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Spin } from 'antd';
import BatcherRuleAddEdit from './batcher_rule_addedit';

class BatcherRuleEdit extends Component {
    constructor(props) {
        super(props)
      
        this.state = {
           edit_data:{},
           edit_id:this.props.config_id,
           loaded:false
        };
  
        this.get_detail=RESTExecutor.detail().config({
          label:'batcher_rule_detail',
      }).forId(this.props.config_id).callbacks((success)=>{
          this.setState({
              edit_data:success.result,
              loaded:true
          })
      }).connect(props.domains.batchergroup);
  
  
        if(this.props.config_id){
       this.get_detail.execute()
      }   
      };
      
    render() {
        const {loaded,edit_data,edit_id}=this.state;
        if(!loaded){
            return <center><Spin/></center>
        }
  
      return (
        <div> 
            <BatcherRuleAddEdit 
            key={`-${edit_id}`}
            edit_id={edit_id}
            edit_data={edit_data}
            onRefresh={()=>{
                this.get_detail.execute()
            }}
            batcher_group_id={this.props.batcher_group_id}
            onClose={this.props.onClose}
            onRefreshClose={this.props.onRefreshClose}
            />
          </div>
      );
    }
  
    componentDidUpdate = (prevProps) => {
      if ( this.props.config_id !== prevProps.config_id) {
  
          this.setState({
              edit_id: this.props.config_id,
              loaded:false
          })
          this.get_detail.forId(this.props.config_id).execute();
  
  
      };
  }
}
export default withDomains(BatcherRuleEdit,"batchergroup");
